<div class="component">
  <h3 [ngClass]="condensed ? 'headerCondensed' : 'header'">
    <a
      [ngClass]="condensed ? 'headerLinkCondensed' : 'headerLink'"
      [routerLink]="linkUrl"
      [queryParams]="linkParams"
      [hidden]="!linkText"
      (click)="linkClick.emit($event)"
    >
      {{ linkText }}
      <i class="fa fa-chevron-right" [hidden]="!linkText" data-icon></i>
    </a>
    <ul class="tabs">
      <li
        *ngFor="let tab of tabs"
        [attr.data-automation-e2e-selector]="tab.header"
        [title]="tab.tooltip"
        [ngClass]="{
          disabledButton: tab.disabled,
          activeTab: tab.active,
          tab: !tab.active
        }"
        (click)="selectTab(tab, true)"
      >
        {{ tab.header }}
      </li>
    </ul>
  </h3>
  <div class="body"><ng-content></ng-content></div>
</div>
